import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import TabComponent from './TabComponent'
import { useSelector } from 'react-redux'
import { getMode } from '../utils/app.utils'
export default function Layout() {
  const { profile } = useSelector(state => state.profile)
  const location = useLocation()
  const navigate = useNavigate()
  const [dataTabs, setDataTabs] = useState([])
  const mode = getMode()

  const seedRawTab = [
    {
      title: 'เมล็ดพันธุ์ดิบคงคลัง',
      url: '/raw/balance',
      Permit: true

    },
    {
      title: 'รับเมล็ดพันธ์ุดิบ',
      url: '/raw/repurchase',
      Permit: true
    },
    {
      title: 'จ่ายเพื่อปรับปรุง',
      url: '/raw/paidforfactory',
      Permit: true
    },
    {
      title: 'รับหลังปรับปรุง',
      url: '/raw/receivedafterimprovement',
      Permit: true
    },
    {
      title: 'จ่ายให้งานตลาด',
      url: '/raw/paidformarketing',
      Permit: true
    },
  ]
  const stockTabs = [
    {
      title: 'เมล็ดพันธุ์คงคลัง',
      url: '/stock/balance',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Balance.Read')?.Permit
    },
    {
      title: 'รับเมล็ดพันธุ์ดี',
      url: '/stock/stock-receive',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Receive.Read')?.Permit
    },
    {
      title: 'เมล็ดพันธุ์คัดออก',
      url: '/stock/stock-culled',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Receive.Read')?.Permit
    },
    {
      title: 'โอนเมล็ดพันธุ์',
      url: '/stock/stock-transfer',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Transfer.Read')?.Permit
    },
    {
      title: 'สำรองเมล็ดพันธุ์ (ศูนย์)',
      url: '/stock/reserve',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Reserve.Read')?.Permit
    },
    {
      title: 'สำรองเมล็ดพันธุ์ (ส่วนกลาง)',
      url: '/stock/reserve-hq',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Reserve.Read')?.Permit
    },
    {
      title: 'ปรับปรุงยอด',
      url: '/stock/stock-adjust',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Adjust.Read')?.Permit
    },
    {
      title: 'ต้นทุนการผลิต',
      url: '/stock/cost',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Adjust.Read')?.Permit
    },
  ]
  const saleTabs = [
    {
      title: 'ขายเมล็ดพันธุ์',
      url: '/sale/item-sale',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Sale.Create')?.Permit
    },
    {
      title: 'รายการขายเมล็ดพันธุ์',
      url: '/sale/coppy-list',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Sale.Read')?.Permit
    },
    {
      title: 'ตั้งราคาเฉพาะกิจ',
      url: '/sale/promotion',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Promotion.Read')?.Permit

    },
    {
      title: 'สรุปการจัดส่งเมล็ดพันธุ์',
      url: '/sale/delivery',
      Permit: true

    },
    {
      title: 'ใบตรวจการปฎิบัติงาน',
      url: '/sale/campaign-plan',
      Permit: true
    },
  ]
  const materialsTabs = [
      {
      title: 'ภาพรวม',
      url: '/materials/materials-dashboard',
      Permit: true

    },
    {
      title: 'วัสดุคงคลัง',
      url: '/materials/materials-balance',
      Permit: true

    },
  
    {
      title: 'รับวัสดุ',
      url: '/materials/materials-receive',
      Permit: true
    },
    {
      title: 'จ่าย / ยืม / ซ่อม',
      url: '/materials/materials-expenses',
      Permit: true
    },
    // {
    //   title: 'แจ้งซ่อมเสร็จ',
    //   url: '/materials/materials-repair',
    //   Permit: true
    // },
    {
      title: 'โอนวัสดุ',
      url: '/materials/materials-transfers',
      Permit: true
    },
    // {
    //   title: 'ยืมวัสดุ',
    //   url: '/materials/materials-lends',
    //   Permit: true
    // },
    {
      title: 'คืนวัสดุ',
      url: '/materials/materials-returns',
      Permit: true
    },
    {
      title: 'ตัดบัญชี',
      url: '/materials/materials-debit',
      Permit: true
    },
 
    // {
    //   title: 'test',
    //   url: '/materials/test',
    //   Permit: false
    // },
    

  ]
  const receiptTaps = [
    {
      title: 'ใบเสร็จ',
      url: '/receipt/receipt-list',
      Permit: true
    },

  ]
  const planTabs = [
    {
      title: 'แผนการผลิต/ทบทวน',
      url: '/plan/production-plan',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'ProductionPlan.Read')?.Permit
    },
    {
      title: 'แผนการจำหน่าย',
      url: '/plan/distribution-plan',
      Permit: true
    },
    {
      title: 'แผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว',
      url: '/plan/promote-spread',
      Permit: true
    },
    

  ]
  const agentTabs = [
    {
      title: 'รายการลูกค้า',
      url: '/agent/customer-list',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Customer.Read')?.Permit

    },
    {
      title: 'รายการตัวแทนจำหน่าย',
      url: '/agent/agent-list',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Agent.Read')?.Permit
    },
  ]
  const settingTabs = [
    {
      title: 'ประเภท, พันธ์ุข้าว & ชนิดของพันธุ์ข้าว',
      url: '/setting/category',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Category.Read')?.Permit
    },
    {
      title: 'รายละเอียดเมล็ดพันธุ์ข้าว',
      url: '/setting/item',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Item.Read')?.Permit
    },
    {
      title: 'ศูนย์เมล็ดพันธุ์ข้าว',
      url: '/setting/branchs',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Branch.Read')?.Permit
    },
    {
      title: 'โรงเก็บ',
      url: '/setting/wherehouse',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Warehouse.Read')?.Permit
    },
    {
      title: 'วัสดุ',
      url: '/setting/materials',
      Permit: true
    },
    {
      title: 'ข่าวสาร',
      url: '/setting/news',
      Permit: false
    },
    {
      title: 'กลุ่มผู้ใช้งาน',
      url: '/setting/role',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Employee.Read')?.Permit
    },
    {
      title: 'ผู้ใช้งานระบบ',
      url: '/setting/employee',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Employee.Read')?.Permit
    },
    {
      title: 'ส่วนลดการขาย',
      url: '/setting/discount-sale',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Discount.Read')?.Permit
    },
    {
      title: 'ปีงบประมาณ',
      url: '/setting/budget-years',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'BudgetYear.Read')?.Permit
    },
    {
      title: 'เปลี่ยนรหัสผ่าน',
      url: '/setting/change-password',
      Permit: true
    },
  ]

  useEffect(() => {
    let Tabs = []
    if (profile) {
      if (location.pathname.includes('/report')) {
        setDataTabs(null)
      }
      if (location.pathname.includes('/')) {
        setDataTabs(null)
      }
      if (location.pathname.includes('/stock')) {
        if (profile?.BranchNo?.BranchNo !== '00') {
          let roleTab = stockTabs.filter(x => x.title !== 'สำรองเมล็ดพันธุ์ (ส่วนกลาง)' && x.title !== 'ปรับปรุงยอด')
          Tabs = roleTab.filter((x) => x.Permit)
        } else {
          Tabs = stockTabs.filter((x) => x.Permit)
        }
        setDataTabs(Tabs)
      }
    if (location.pathname.includes('/raw')) {
        Tabs = seedRawTab.filter((x) => x.Permit)
        setDataTabs(Tabs)
      }
      if (location.pathname.includes('/sale')) {
        if (profile?.BranchNo?.BranchNo !== '00') {
          let roleTab = saleTabs.filter(x => x.title !== 'ตั้งราคาเฉพาะกิจ')
          Tabs = roleTab.filter((x) => x.Permit)
        } else {
          Tabs = saleTabs.filter((x) => x.Permit)
        }
        setDataTabs(Tabs)
      }
      if (location.pathname.includes('/materials')) {
        Tabs = materialsTabs.filter((x) => x.Permit)
        setDataTabs(Tabs)
      }
      if (location.pathname.includes('/receipt')) {
        Tabs = receiptTaps.filter((x) => x.Permit)
        setDataTabs(Tabs)
      }
      if (location.pathname.includes('/plan')) {
        Tabs = planTabs.filter((x) => x.Permit)
        setDataTabs(Tabs)
      }
      if (location.pathname.includes('/agent')) {
        Tabs = agentTabs.filter((x) => x.Permit)
        setDataTabs(Tabs)
      }
      if (location.pathname.includes('/setting')) {
        if (mode !== 'online' || profile?.BranchNo?.BranchNo !== '00') {
          let roleTab = settingTabs.filter(x => x.title === 'โรงเก็บ' || x.title === 'เปลี่ยนรหัสผ่าน')
          Tabs = roleTab.filter((x) => x.Permit)
        } else {
          Tabs = settingTabs.filter((x) => x.Permit)
        }
        setDataTabs(Tabs)
      }
    }
    if (location.pathname === '/stock'  || location.pathname === '/raw' || location.pathname === '/sale' || location.pathname === '/materials' || location.pathname === '/receipt' || location.pathname === '/agent' || location.pathname === '/setting') {
      navigate(Tabs[0]?.url)
    }
  }, [location.pathname, profile])
  return (
    <Grid container sx={{ height: '100vh',overflow:'hidden' }}>
      <Grid item md={0.5} xs={1.5} sx={{ background: '#3364af', }}>
        <Sidebar />
      </Grid>
      <Grid item md={11.5} xs={10.5} className="col-12 bd-content pt-3 pb-3" style={{ backgroundColor: '#ebebeb', height: '100vh', overflowY: 'auto', padding: '10px 30px' }}>
      {/* <Grid item md={11.5} xs={10.5} className="col-12 bd-content pt-3 pb-3" style={{ backgroundColor: '#F7F8FA', height: '100vh', overflowY: 'auto', padding: '10px 30px' }}> */}
        <Header />
        {dataTabs && <TabComponent dataTabs={dataTabs} />}
        <Outlet />
      </Grid>
    </Grid>
  )
}
